export const INIT_CONTEXT = {
    loadingRequest: {
        value: false,
        hide: () => { }, show: () => { }
    },
    data: {
        campusList: [],
        resourceModuleList: [],
        libraryList: [], 
        resourceTypes: [],
        spaceTypeList: [],
        allDays: []
    },
    resourceModuleId: 0
};